import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const IntroOverlay = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[200] bg-[#050505] flex items-center justify-center"
          data-testid="intro-overlay"
        >
          <div className="flex items-center gap-4 text-white">
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: 60 }}
              transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
              className="h-[1px] bg-[#FF5A00]"
            />
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="font-mono-label text-white/80"
            >
              El Elyon Air · Ready
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
